<template>
    <div>
        <div class="modal fade" id="generalModal" tabindex="-1" role="dialog" aria-labelledby="generalModal" aria-modal="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="card card-custom">
                            <div class="card-body">
                                <ul class="nav nav-tabs nav-tabs-line nav-tabs-line-right nav-cursor">
                                    <a class="nav-link  font-weight-bolder" @click="showTab=1;activeTab='Details'"  :class="[activeTab==='Details' ? 'active' : '']">{{$t('details')}}</a>
                                    <a class="nav-link  font-weight-bolder" @click="showTab=2;activeTab='Gallery'"  v-if="imagesExistance && defualtImageExistance" :class="[activeTab==='Gallery' ? 'active' : '']">{{$t('gallery')}}</a>
                                    <a class="nav-link  font-weight-bolder" @click="showTab=2;activeTab='Gallery'" v-else-if="open_product_from_order && defualtImageExistance" :class="[activeTab==='Gallery' ? 'active' : '']">{{$t('gallery')}}</a>
                                    <a class="nav-link  font-weight-bolder" @click="showTab=3;activeTab='Variants'" v-if="product.variants != null"  :class="[activeTab==='Variants' ? 'active' : '']">{{$t('variants')}}</a>
                                    <a class="nav-link  font-weight-bolder" @click="showTab=4;activeTab='BundleProducts'" v-if="product.is_bundle"  :class="[activeTab==='BundleProducts' ? 'active' : '']">{{$t('bundle_products')}}</a>
                                </ul>
                                <ul class="float-right" style="margin-top: -45px;" type="none">
                                    <li class="kt-menu__item  kt-menu__item--submenu kt-menu__item--rel nav-item">
                                        <button type="button" class="btn btn-clean btn-sm btn-icon btn-icon-md pull-right close"  @click="showTab=1;activeTab='Details';handleCloseModel()"  data-dismiss="modal" aria-label="Close">
                                            <i class="flaticon2-cross"></i>
                                        </button>
                                    </li>
                                </ul>
                                <div v-if="showTab===1">
                                  <ProductDetails :key="componentKey" :selected-variant="variant" @update:selectedVariant="updateSelectedVariant" :product="product" :settings="settings" :show_product_details="product_details" :open_product_from_order="open_product_from_order" :msrp="msrp"></ProductDetails>
                                </div>
                                <div v-if="showTab===2 && imagesExistance && defualtImageExistance">
                                  <ProductImages :key="componentKey" :product="product" :show_product_details="product_details"></ProductImages>
                                </div>
                                <div v-if="showTab===3 && product.variants != null">
                                  <VariantListing :key="componentKey" :productVariants="product.variants" :settings="settings" :track_inventory="product.settings.show_inventory" :retail_price="product.settings.show_retail_price_to_customers" :msrpName="product.msrpDisplayName"></VariantListing>
                                </div>
                                <div v-if="showTab===4 && product.is_bundle">
                                  <BundleProducts :key="componentKey" :product-bundles="product.bundle_products" :settings="settings" :variant="variant" :product_details="product_details" :msrp="msrp"
                                  ></BundleProducts>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import ProductDetails from './product-variants/product-details.vue';
import VariantListing from './product-variants/variants-listing.vue';
import ProductImages from './product-variants/product-images.vue';
import BundleProducts from './product-variants/bundle-products.vue';

import { ref, defineProps, onMounted, computed, onBeforeUnmount } from 'vue';
import eventBus from '@/js/utils/eventBus';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  settings: {
    type: Object,
    required: false,
  },
  product_details: {
    type: Boolean,
    required: true,
  },
  open_product_from_order: {
    type: Boolean,
    required: false,
  },
  msrp: {
    type: String,
    required: false,
  },
});

const store = useStore();
const { t } = useI18n();
const min = ref(1);
const step = ref(1);
const quantityValue = ref(0);
const quantityDisable = ref(false);
const enableVariantPrice = ref(false);
const showTab = ref(1);
const activeTab = ref('Details');
const variant = ref('');
const componentKey = ref(0);

onMounted(() => {
  $('#generalModal').modal({ backdrop: 'static' });

  eventBus.on('ProductVariants::openModal', (data) => {
     variant.value = ''
    // Rerender the component when reopen the modal. Each time, ours componentKey change. When this happens, Vue will know that it must destroy the component and create a new component. What we get is a child component that will reinitialize itself and “reset” its state.
    componentKey.value += 1;
    if (data.variants_details) {
      showTab.value = 1;
      activeTab.value = 'Details';
      eventBus.emit('Product::variantDetails', props.product_details, data.product);
    }
  });
  if (props.product.allowMultiplePurchase) {
    setAttributesQuantity(false, props.product.min_pur_qty, props.product.min_pur_qty, props.product.min_pur_qty);
  } else {
    setAttributesQuantity(false, 1, 1, props.product.min_pur_qty);
  }
  enableVariantPrice.value = (!props.product.hasVariants) ? true : false;
});

const imagesExistance = computed(() => {
  return  props.product.formatted_images?.images?.length > 0 ? true : false;
});

const defualtImageExistance = computed(() => {
    return props.product.formatted_images?.default_image ? true : false;
});

// Listening for an event emitted from the child (product-details.vue)
const updateSelectedVariant = (newVariant) => {
  variant.value = newVariant;
};

const setAttributesQuantity = (quantityDisableVal, minVal, stepVal, valueVal) => {
  quantityDisable.value = quantityDisableVal;
  min.value = minVal;
  step.value = stepVal;
  quantityValue.value = valueVal;
};

const handleCloseModel = () => {
  store.commit('OPEN_ORDER_DETAIL_MODAL', false);
};


onBeforeUnmount(() => {
      eventBus.off('ProductVariants::openModal');
      $('#generalModal').modal('hide');
    });

</script>
<style scoped>

.nav-cursor{
    cursor: pointer;
}
@media (max-width: 600px) {
    #generalModal .modal-dialog {
        width: calc(100% - 1rem);
        max-width: none;
        margin: 0.5rem;
    }
    #generalModal .modal-body,
    #generalModal .card-body {
        padding-right: 1rem;
        padding-left: 1rem;
    }
}
</style>
